import { render } from "./SingleLocation.vue?vue&type=template&id=0a6749c7"
import script from "./SingleLocation.vue?vue&type=script&lang=js"
export * from "./SingleLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__